/**
 * AI 业务中台模块配置 — 聚合入口
 *
 * 新增模块规则：
 * 1. 在 modules/ 下创建 {模块名}.ts，导出 {模块名}Module 常量
 * 2. 在下方 AI_BUSINESS_CENTER_MODULES 数组添加
 * 3. 不要修改其他模块的文件！
 */

export type { AiBusinessCenterModule } from './types'

// ========== 模块导出 ==========
export { reportModule } from './modules/report'
export { crmModule } from './modules/crm'
export { scrmModule } from './modules/scrm'
export { erpModule } from './modules/erp'
export { wmsModule } from './modules/wms'
export { mesModule } from './modules/mes'
export { orderManagementModule } from './modules/orderManagement'
export { cityGovernanceModule } from './modules/cityGovernance'
export { iotModule } from './modules/iot'
export { archiveModule } from './modules/archive'
export { tenderModule } from './modules/tender'
export { biddingModule } from './modules/bidding'
export { partyModule } from './modules/party'
// export { traceModule } from './modules/trace'
// export { dataplatModule } from './modules/dataplat'
export { oaModule } from './modules/oa'
export { srmModule } from './modules/srm'
export { contractModule } from './modules/contract'
export { aftersaleModule } from './modules/aftersale'
export { fmsModule } from './modules/fms'
export { pmsModule } from './modules/pms'
export { hrmModule } from './modules/hrm'
export { pjmModule } from './modules/pjm'
import { reportModule } from './modules/report'
import { crmModule } from './modules/crm'
import { scrmModule } from './modules/scrm'
import { erpModule } from './modules/erp'
import { wmsModule } from './modules/wms'
import { mesModule } from './modules/mes'
import { orderManagementModule } from './modules/orderManagement'
import { cityGovernanceModule } from './modules/cityGovernance'
import { iotModule } from './modules/iot'
import { archiveModule } from './modules/archive'
import { tenderModule } from './modules/tender'
import { biddingModule } from './modules/bidding'
import { partyModule } from './modules/party'
// import { traceModule } from './modules/trace'
// import { dataplatModule } from './modules/dataplat'
import { oaModule } from './modules/oa'
import { srmModule } from './modules/srm'
import { contractModule } from './modules/contract'
import { aftersaleModule } from './modules/aftersale'
import { fmsModule } from './modules/fms'
import { pmsModule } from './modules/pms'
import { hrmModule } from './modules/hrm'
import { pjmModule } from './modules/pjm'

import type { AiBusinessCenterModule } from './types'

export const AI_BUSINESS_CENTER_MODULES: AiBusinessCenterModule[] = [
  reportModule,
  crmModule,
  scrmModule,
  erpModule,
  wmsModule,
  mesModule,
  orderManagementModule,
  cityGovernanceModule,
  iotModule,
  archiveModule,
  tenderModule,
  biddingModule,
  partyModule,
  // traceModule,
  // dataplatModule,
  oaModule,
  srmModule,
  contractModule,
  aftersaleModule,
  fmsModule,
  pmsModule,
  hrmModule,
  pjmModule
]

export const AI_BUSINESS_CENTER_MENU_TITLES = AI_BUSINESS_CENTER_MODULES.flatMap((item) => [
  item.label,
  ...(item.aliases || [])
])
